// src/components/WhyUs.js
import React from 'react';
import './WhyUs.css';

const WhyUs = () => {
  return (
    <section className="why-us-section">
      <div className="container why-us-content">
        <h2>WHY <span>TRONIXAI</span>?</h2>
        <p>We are your end-to-end partner, from concept to creation. tronixAI uniquely combines hardware, software, and structural expertise to deliver truly innovative and integrated solutions that drive efficiency and growth.</p>
        <a href="/about" className="learn-more-link">LEARN MORE ABOUT US</a>
      </div>
    </section>
  );
};

export default WhyUs;